import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20breathtaking%20cinematic%20anime%20scene%20with%20a%20group%20of%20diverse%20characters%20standing%20together%20under%20a%20starry%20night%20sky%20with%20cherry%20blossom%20trees%2C%20warm%20golden%20glow%20from%20distant%20city%20lights%2C%20film%20grain%20texture%2C%20emotional%20and%20inspiring%20atmosphere%2C%20painterly%20cinematic%20anime%20art%20style%2C%20wide%20panoramic%20composition&width=1400&height=600&seq=cta-bg-anime&orientation=landscape"
              alt="立即开始免费观看高清动漫"
              title="免费观看高清动漫，立即开始"
              className="w-full h-52 md:h-72 object-cover"
              loading="lazy"
            />
          </div>

          <div className="text-center mt-10">
            <p className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              免费观看
              <br />
              <span className="font-light italic text-foreground-600">高清动漫</span>
              <br />
              <span className="font-bold">立即开始</span>
            </p>

            <p className="text-foreground-500 text-sm mt-4 max-w-md mx-auto">
              无需注册，无需付费，打开即看。海量动漫资源等你来发现。
            </p>

            <Link
              to="/category/japanese-anime"
              className="inline-flex items-center gap-2 mt-8 px-10 py-4 rounded-full bg-foreground-950 text-white font-semibold text-base hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-xl"></i>
              开始免费观看
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}